import React from "react";
import styles from "./FooterPage.module.scss";

function FooterPage({ style = {} }: { style?: React.CSSProperties }) {
  return (
    <footer className={styles.footer} style={style}>
      <div className={styles.footerContent}>
        <span>
          © Copyright Open Parachute {new Date().getFullYear() || "2022"}
        </span>
        <span>
          <a
            href="https://openparachuteschools.com/privacy-policy/"
            target="_blank"
            className={styles.footerLink}
          >
            Privacy Policy
          </a>
          <a
            href="https://openparachuteschools.com/terms-of-use-app/"
            target="_blank"
            className={styles.footerLink}
          >
            Terms of Service
          </a>
        </span>
      </div>
    </footer>
  );
}

export default FooterPage;
